// extracted by mini-css-extract-plugin
module.exports = {"container":"discount-alert-module__container___4xEjH","offerIcon":"discount-alert-module__offerIcon___dodvi"};